import { Field } from '@rental/ui'
import { StaffInput } from './ui'

/** What the server takes as a code: the authenticator app's six digits. */
export const OWNER_CODE = /^\d{6}$/

/**
 * The Owner's code, wherever their word is needed: the privacy panel, the
 * terms put in force, access granted on Persone (S9). Six digits from the
 * authenticator app, spent by the server once, in the same transaction as
 * the change and whether or not the change went through: the caller empties
 * it after any answer, and a new one is typed. Each place names it in its
 * own words, as its question asks it.
 */
export function OwnerCodeField({
  label,
  value,
  onChange,
  className,
}: {
  label: string
  value: string
  onChange: (value: string) => void
  className?: string
}) {
  return (
    <Field className={className} label={label} required>
      {(control) => (
        <StaffInput
          {...control}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          value={value}
          onChange={(event) => onChange(event.target.value.replace(/\D/g, ''))}
        />
      )}
    </Field>
  )
}
